import React, { useEffect, useState } from 'react';

const EducationModal = ({ isOpen, onClose, initialDegree = '', initialUniversity = '', initialGrade = '', initialStart = '', initialEnd = '', initialDetails = '', onSave, onEnhance }) => {
  const [degree, setDegree] = useState(initialDegree || '');
  const [university, setUniversity] = useState(initialUniversity || '');
  const [grade, setGrade] = useState(initialGrade || '');
  const [startDate, setStartDate] = useState(initialStart || '');
  const [endDate, setEndDate] = useState(initialEnd || '');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setDegree(initialDegree || '');
    setUniversity(initialUniversity || '');
    setGrade(initialGrade || '');
    setStartDate(initialStart || '');
    setEndDate(initialEnd || '');
  }, [initialDegree, initialUniversity, initialGrade, initialStart, initialEnd, isOpen]);

  if (!isOpen) return null;

  const handleEnhance = async () => {
    if (!onEnhance) return;
    try {
      setLoading(true);
      const inputText = `${degree}${university ? '\n' + university : ''}${grade ? '\n' + grade : ''}`;
      const enhanced = await onEnhance(inputText);
      if (enhanced) {
        const lines = String(enhanced).split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
        if (lines.length >= 1) setDegree(lines[0]);
        if (lines.length >= 2) setUniversity(lines[1]);
        if (lines.length >= 3) setGrade(lines[2]);
      }
    } catch (err) {
      console.error('EducationModal enhance error', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = () => {
    if (onSave) onSave({ degree: degree || '', university: university || '', grade: grade || '', startDate, endDate });
  };

  return (
    <div style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, background: 'rgba(0,0,0,0.4)' }}>
      <div style={{ width: 720, maxWidth: '95%', background: '#fff', borderRadius: 6, padding: 20, boxShadow: 'rgba(0,0,0,0.2) 0px 6px 24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0 }}>Edit Education</h3>
          <button aria-label="Close" onClick={onClose} style={{ background: 'transparent', border: 'none', fontSize: 20 }}>×</button>
        </div>

        <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>Degree / Education name</label>
        <input type="text" placeholder="Degree / Education name" value={degree} onChange={(e) => setDegree(e.target.value)} className="section-input" style={{ width: '100%', marginBottom: 8 }} />

        <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>University name</label>
        <input type="text" placeholder="University name" value={university} onChange={(e) => setUniversity(e.target.value)} className="section-input" style={{ width: '100%', marginBottom: 8 }} />

        <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>Grade / CGPA</label>
        <input type="text" placeholder="Grade / CGPA" value={grade} onChange={(e) => setGrade(e.target.value)} className="section-input" style={{ width: '100%', marginBottom: 8 }} />

        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <div style={{ flex: 1 }}>
            <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>Start date</label>
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="section-input-date" style={{ width: '100%' }} />
          </div>
          <div style={{ flex: 1 }}>
            <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>End date</label>
            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="section-input-date" style={{ width: '100%' }} />
          </div>
        </div>

        

        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 12 }}>
          <button type="button" className="btn btn-secondary" onClick={handleEnhance} disabled={loading}>{loading ? 'Enhancing...' : 'Enhance with AI'}</button>
          <button type="button" className="btn btn-primary" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default EducationModal;
